import type { ReactNode } from 'react';
import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';

export interface StatItem {
  icon: ReactNode;
  label: ReactNode;
  value: ReactNode;
  /** Semantic token for the icon colour, e.g. "var(--vn-success-solid)". */
  tone: string;
}

/** A row of summary cards (icon + label + big value) — leave/business overviews. */
export function AccountStatCards({ items }: { items: StatItem[] }) {
  return (
    <StatGroup columns={items.length}>
      {items.map((s, i) => (
        <Card key={i} flat>
          <CardBody>
            <Stat
              label={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--vn-space-2)' }}>
                  <span style={{ color: s.tone, display: 'inline-flex' }}>{s.icon}</span>
                  {s.label}
                </span>
              }
              value={s.value}
            />
          </CardBody>
        </Card>
      ))}
    </StatGroup>
  );
}
